import * as React from 'react';
import Page from '../Page';
import DataSummary939 from './CourtReporting939DataSummaryCore';
import { UserRoleEnum } from '../../redux/UserSlice';




const CourtReporting939Summary = (props: any) => {

    return (
        <React.Fragment>
            <Page>
                <DataSummary939 userRole={UserRoleEnum.EntityUser} dataSection="Summary" />
            </Page>
        </React.Fragment>
    );
}

export default CourtReporting939Summary;